// extracted by mini-css-extract-plugin
module.exports = {"container":"HomeConfigPage_container__jlPDc"};